import _ from 'lodash'

const http = require('http')
const https = require('https')
const vm = require('vm')
const fetch = require('node-fetch')
const util = require('util')
const qs = require('qs')
const httpAgent = new http.Agent({
  keepAlive: true,
})
const httpsAgent = new https.Agent({
  keepAlive: true,
})
const debug = false // 仅调试用

// 尽可能保持与 _prefetchApi.js 代码一致，以便保持两端行为一致

const globalVmContext = vm.createContext({})

module.exports.request = function (
  req,
  res,
  prefetchApiConfig,
  configMap,
  prefetchApiMock,
  port
) {
  var storeTaskMap = {}

  // 表达式参数
  var paramScope = resolveParamScope(req)
  if (debug) {
    console.log('param', paramScope)
  }

  // 执行任务
  for (var propKey in configMap) {
    if (configMap.hasOwnProperty(propKey)) {
      var rawConfig = configMap[propKey]
      var task = normalizeTask(propKey, prefetchApiConfig, rawConfig)
      storeTaskMap[propKey] = task
      tryRequest(
        req,
        res,
        task,
        resolveRequest(req, prefetchApiConfig, paramScope, task.config),
        prefetchApiMock
      )
    }
  }

  return storeTaskMap
}

// 提供 fallback 支持，允许任务多次尝试启动
module.exports.fallback = function (
  req,
  res,
  prefetchApiConfig,
  task,
  fallback
) {
  task.status = 'FALLBACK'
  task.fallback = new Promise(async (resolve) => {
    var paramScope = resolveParamScope(req)
    if (fallback) {
      const fallbackResult = await fallback(task.propKey, paramScope)
      if (fallbackResult) {
        if (process.env.NODE_ENV === 'development') {
          throw new Error(
            'fallback 返回值用法已废弃，请直接修改 paramScope 参数'
          )
        }
      }
      tryRequest(
        req,
        res,
        task,
        resolveRequest(req, prefetchApiConfig, paramScope, task.config)
      )
      resolve()
    } else {
      task.status = 'CANCEL'
      task.fallback = undefined
      resolve()
    }
  })
}

function tryRequest(rawReq, rawRes, task, resolvedRequest, prefetchApiMock) {
  // 支持 2 种行为
  // 1. 按条件取消任务(对应props值为cancel)，条件不具备时不再发起请求，页面需自行处理降级
  // 2. 常规立即请求
  // **不支持** 多个任务间的逻辑串行，防止业务滥用拉长关键路径
  if (!resolvedRequest.enabled) {
    task.status = 'CANCEL'
  } else {
    task.status = 'LOADING'
    if (prefetchApiMock && prefetchApiMock[task.propKey]) {
      // 有 Mock 数据时，直接模拟请求响应过程
      // 外部对是否 mock 无感知
      task.status = 'LOADING'
      task.request = new Promise((resolve) => {
        setTimeout(() => {
          task.status = 'COMPLETE'
          task.response = {
            success: true,
            response: {
              response: { status: 200, statusText: 'OK' },
              data: prefetchApiMock[task.propKey],
            },
          }
          resolve(task.response)
        }, 0)
      })
    } else {
      if (debug) {
        console.log('fetch start', resolvedRequest)
      }
      task.request = new Promise((resolve, reject) => {
        xhr(
          rawRes,
          resolvedRequest.method,
          resolvedRequest.url,
          resolvedRequest.data,
          {
            type: resolvedRequest.type,
            headers: resolveHeaders(rawReq.headers, resolvedRequest.headers),
            complete: function (success, response) {
              task.status = 'COMPLETE'
              task.response = { success: success, response: response }
              resolve(task.response)
            },
          }
        ).catch(reject)
      })
    }
  }
}

function resolveHeaders(rawHeaders, appendHeaders) {
  if (!rawHeaders) return appendHeaders
  if (!appendHeaders) appendHeaders = {}
  if (rawHeaders['x-forwarded-for']) {
    appendHeaders['x-forwarded-for'] = rawHeaders['x-forwarded-for']
  }
  if (rawHeaders['x-real-ip']) {
    appendHeaders['x-real-ip'] = rawHeaders['x-real-ip']
  }
  return appendHeaders
}

function resolveParamScope(req) {
  var $location = {
    protocol: 'http:',
    host: req.headers.host,
    pathname: req.originalUrl.replace(/\?.*$/, ''),
  }
  var $cookie = req.cookies
  var $query = req.query
  var $platform = getPlatformInfo(req.headers['user-agent'])
  var paramScope = {
    $location,
    $cookie,
    $query,
    $fallback: {},
    $platform: $platform,
  }
  if (debug) {
    console.log('param', paramScope)
  }
  return paramScope
}

function normalizeTask(propKey, prefetchApiConfig, rawConfig) {
  if (!rawConfig.url) {
    throw new Error('task(' + propKey + ') has no valid url')
  }
  return {
    propKey: propKey,
    config: {
      critical: rawConfig.critical === undefined ? false : !!rawConfig.critical,
      enabled: rawConfig.enabled === undefined ? true : rawConfig.enabled,
      method: !rawConfig.method ? 'GET' : rawConfig.method.toUpperCase(),
      url: rawConfig.url,
      data: rawConfig.data,
      type: (rawConfig.type || prefetchApiConfig.type || 'URL').toUpperCase(),
      headers: rawConfig.headers,
    },
    category: rawConfig.category,
    status: 'INITIAL',
    request: undefined,
    response: undefined,
  }
}

function resolveRequest(req, prefetchApiConfig, paramScope, config) {
  var paramScopeJsonString = JSON.stringify(paramScope)
  var evalResult = safeEvalScriptObject(paramScopeJsonString, {
    url: config.url,
    enabled:
      typeof config.enabled === 'string' ? config.enabled : !!config.enabled,
    gateway: prefetchApiConfig.gateway || '',
    data: config.data || {},
    headers: { ...prefetchApiConfig.headers, ...config.headers },
  })

  // http://domain/path
  // //domain/path
  // /path
  var url = evalResult.url
  if (!/^(https?:|\/\/)/.test(url) && evalResult.gateway) {
    url = evalResult.gateway + '/' + url
  }
  if (!/^(https?:|\/\/)/.test(url)) {
    // express升级到5.x 可直接用req.host，参考地址 https://expressjs.com/en/guide/migrating-5.html#req.host
    url = req.protocol + '://' + req.headers.host + '/' + url
  }
  if (/^\/\//.test(url)) {
    url = req.protocol + url
  }
  url = url.replace(/\/{2,}/g, '/').replace(/^(\w+:\/)/, '$1/')

  return {
    enabled: evalResult.enabled,
    method: config.method,
    url: url,
    data: evalResult.data,
    headers: {
      ...evalResult.headers,
      'user-agent': req.headers['user-agent'],
      cookie: req.headers.cookie,
    },
    type: config.type,
  }
}

// 将参数对象中包含的 string value 视为 script 尝试执行
function safeEvalScriptObject(paramScopeJsonString, paramObject) {
  function cloneAndFindSubString(o, func) {
    if (Object.prototype.toString.call(o) === '[object Array]') {
      var tmpResult1 = new Array(o.length)
      for (var i = 0; i < o.length; i++) {
        // 未处理循环引用
        tmpResult1[i] = cloneAndFindSubString(o[i], func)
        if (typeof tmpResult1[i] === 'string') {
          func(o, i)
        }
      }
      return tmpResult1
    } else if (typeof o === 'object' && o) {
      // null
      var tmpResult2 = {}
      for (var k in o) {
        if (o.hasOwnProperty(k)) {
          // 未处理循环引用
          tmpResult2[k] = cloneAndFindSubString(o[k], func)
          if (typeof tmpResult2[k] === 'string') {
            func(tmpResult2, k)
          }
        }
      }
      return tmpResult2
    } else {
      // 此处不做 string 判定
      // 首次遍历时，为对象，不会是 string。之后在内部循环遍历后判定
      return o
    }
  }

  // 参数格式非法，结束
  if (!paramObject || typeof paramObject !== 'object') {
    return
  }

  // 递归遍历参数对象，提取待转换 script 文本
  // 记录提取位置，转换后直接按原位置更新，不再遍历
  // 并产生副本结果对象，最终返回
  var toBeConvertedScriptList = []
  var toBeReplacedList = []
  var result = cloneAndFindSubString(paramObject, function (o, k) {
    toBeConvertedScriptList.push(o[k])
    // 记录待插入位置，之后不再遍历参数对象
    toBeReplacedList.push([o, k])
  })

  // 执行批量转换
  var convertedList = safeEvalInner(
    paramScopeJsonString,
    toBeConvertedScriptList
  )

  // 替换参数对象里的指定位置
  for (var i = 0; i < convertedList.length; i++) {
    var toBeReplacedItem = toBeReplacedList[i]
    toBeReplacedItem[0][toBeReplacedItem[1]] = convertedList[i] // 不需要额外检查 o 是数组还是对象，操作语法一样
  }

  // 返回
  return result
}

// safeEval 是个慢操作，需要调用场景尽量提前收集待解析 script，一次执行完成
function safeEvalInner(paramScopeJsonString, paramScriptList) {
  // nodejs 端不能直接使用 with+eval，极大的安全和内存风险
  // 使用 vm.createContext 机制

  // 传入参数为 [ "$cookie.a ? 'a' : 'b'", "x.x.x()" ] 的形式，数组中的每一项都是字符表达式（执行过程可能报错）
  // 转换为下列格式的待执行脚本
  // with ({
  //   scopeKey: 'scopeValue'
  // }) {
  //   output_key = ([
  //     (function() {
  //       try {
  //         return eval(
  //           "$cookie.a ? 'a' : 'b'"
  //         )
  //       } catch (e) {
  //         return `$cookie.a ? 'a' : 'b'`
  //       }
  //     })(),
  //     (function() {
  //       try {
  //         return eval(
  //           "x.x.x()"
  //         )
  //       } catch (e) {
  //         return `x.x.x()`
  //       }
  //     })(),
  //   ])
  // }
  // 最终在执行上下文全局对象的 output_key 上，可获得结果数组 [ 成功执行的值, "x.x.x()" ]

  // 参数中的 script，转换为待执行的数组结构，以便一次性执行多个 参数script
  // 见上方的代码示例
  var tmpParamScriptList = [] // 使用数组暂存中间字符串优化性能
  for (var i = 0; i < paramScriptList.length; i++) {
    //  (function(){
    //    try {
    //      return eval(scriptText)
    //    } catch (e) {
    //      return scriptText
    //    }
    //  })()
    /// 多个 script 同时执行时，必须使用 eval(string) 的方式，否则无法排除单个 string 不是合法的 js 语法，导致整个拼接表达式失败的问题
    var scriptText = JSON.stringify(paramScriptList[i])
    tmpParamScriptList.push(
      `(function(){ try{ return eval(${scriptText}) }catch(e){ return ${scriptText} } })()`
    )
  }

  // 使用 vm.context 执行 script 文本
  try {
    const REQUEST_FIELD_NAME = `result_yA6C62EDw6V004pV`

    // 性能优化
    // 历史版本，在每次 safeEval 时，vm.createContext() 创建 context。实际 createContext 将创建 sandBox，极度缓慢
    // 调整为全局复用 context
    // 实际验证，性能是每次创建 context 的 50 倍（不含 scope JSON 序列化）
    // TODO 需要过滤内容，方式通过构造 query 等方式提交合法的 javascript，在此执行。尽管 sandbox 能挡住大部分攻击
    vm.runInContext(
      `with(${paramScopeJsonString}) { ${REQUEST_FIELD_NAME} = ([${tmpParamScriptList.join(
        ','
      )}]) }`,
      globalVmContext
    )

    // 执行结果
    const vmResult = globalVmContext[REQUEST_FIELD_NAME]

    // 从 context 中清除执行结果
    // 注意，可能参数 script 预期外的往 context 写入未知内容，导致内存泄漏
    // TODO 定期重建 context，以排除可能的内存泄漏
    vm.runInContext(`delete ${REQUEST_FIELD_NAME}`, globalVmContext)

    return vmResult
  } catch (err) {
    // 发生异常，返回最原始的参数对象
    return paramScriptList
  }
}

function xhr(rawRes, method, url, data, opts) {
  var contentType
  // 注意，GET请求，总是以 url 形式发送
  if (method === 'GET' || opts.type === 'URL') {
    contentType = 'application/x-www-form-urlencoded; charset=utf-8'
    var dataQs
    if (data) {
      if (typeof data === 'string') {
        dataQs = data
      } else {
        var qsList = []
        for (var key in data) {
          if (data.hasOwnProperty(key)) {
            qsList.push(
              encodeURIComponent(key) + '=' + encodeURIComponent(data[key])
            )
          }
        }
        dataQs = qsList.join('&')
      }
    }
    if (method === 'GET') {
      if (dataQs) {
        url = url + '?' + dataQs
      }
      data = undefined
    } else {
      data = dataQs
    }
  } else {
    contentType = 'application/json; charset=utf-8'
    if (data && typeof data !== 'string') {
      data = JSON.stringify(data)
    }
  }

  const options = {
    method,
    body: data,
    headers: {
      ...opts.headers,
      'Content-Type': contentType,
    },
    timeout: 30 * 1000, // client 和 server 默认是 30，业务为 60
    agent: function (_parsedURL) {
      if (_parsedURL.protocol === 'http:') {
        return httpAgent
      } else {
        return httpsAgent
      }
    },
  }

  const hrtime = process.hrtime()

  return fetch(url, options).then(
    async (res) => {
      var resText = await res.text()

      const diff = process.hrtime(hrtime)
      const diffTime = diff[0] * 1e3 + diff[1] / 1e6
      rawRes.append(
        'X-AL-PrefetchApi-HTTP-Info',
        `${res.status} ${url
          .replace(/^\w+:\/\/.+?\//, '/')
          .replace(/\?.*$/, '')} ${diffTime.toFixed(3)}ms`
      )

      var success = res.status >= 200 && res.status < 300
      var resJson
      try {
        resJson = JSON.parse(resText)
      } catch (err) {
        // no stuff
      }

      // 将接口下发的 cookie，写入本次请求
      const remoteCookie = res.headers['set-cookie']
      if (Array.isArray(remoteCookie)) {
        remoteCookie.forEach((content) => {
          rawRes.append('Set-Cookie', content)
        })
      }

      prettyLog(
        'response',
        diffTime,
        formatRequestConfig({ url, ...options, data: options.body }),
        formatResponse({
          status: res.status,
          statusText: res.statusText,
          responseData: resJson || resText,
          responseHeaders: res.headers,
        }),
        success ? 'debug' : 'warn'
      )

      if (success) {
        opts.complete(true, { data: resJson || resText, request: res })
      } else {
        opts.complete(false, {
          data: resJson || resText,
          response: { status: res.status, statusText: res.statusText },
          request: res,
        })
      }
    },
    (error) => {
      const diff = process.hrtime(hrtime)
      const diffTime = diff[0] * 1e3 + diff[1] / 1e6
      rawRes.append(
        'X-AL-PrefetchApi-HTTP-Info',
        `${error.code || error.errno || ''} ${url
          .replace(/^\w+:\/\/.+?\//, '/')
          .replace(/\?.*$/, '')} ${diffTime.toFixed(3)}ms`
      )

      prettyLog(
        error.message,
        diffTime,
        formatRequestConfig({ url, ...options, data: options.body }),
        formatResponse({
          status: 0,
          statusText: error.code || error.errno || error.type,
          responseData: error,
          responseHeaders: {},
        }),
        'warn'
      )

      opts.complete(false, {
        data: undefined,
        message: error.message,
        response: {
          status: 0,
          statusText: error.code || error.errno || error.type,
        },
      })
    }
  )
}

// 格式化方法见业务工程 IO

const LOG_HEADER_LIST = [
  'dt',
  'vc',
  'ak-token',
  'cookie',
  'set-cookie',
  'referer',
  'user-agent',
  'content-type',
]

function formatRequestConfig({ method, url, data, headers }) {
  return [
    method,
    url,
    data ? stringify(data) : `''`,
    JSON.stringify(_.pick(headers, LOG_HEADER_LIST)),
  ].join(' ')
}

function formatResponse({ status, statusText, responseData, responseHeaders }) {
  return [
    status + ' ' + statusText,
    responseData ? convertResponseToString(responseData) : `''`,
    JSON.stringify(_.pick(responseHeaders, LOG_HEADER_LIST)),
  ].join(' ')
}

function prettyLog(message, time, requestInfo, responseInfo, logLevel = 'log') {
  console[logLevel](
    [message, Number(time).toFixed(3) + 'ms', requestInfo, responseInfo].join(
      ' | '
    )
  )
}

function stringify(data) {
  let obj
  if (typeof data === 'string') {
    try {
      obj = qs.parse(data)
    } catch (e1) {
      try {
        obj = JSON.parse(data)
      } catch (e2) {
        // no stuff
      }
    }
  }
  if (!obj) {
    obj = data
  }
  return typeof obj === 'string' ? obj : JSON.stringify(obj)
}

function convertResponseToString(resp) {
  if (!resp) {
    return resp + ''
  }
  if (typeof resp === 'string') {
    return resp
  }
  return util
    .inspect(resp, { depth: 3, compact: true })
    .replace(/\s*\n\s*/g, ' ')
}

function getPlatformInfo(ua = '') {
  var result = {
    os: undefined,
    version: undefined,
  }
  result.os = /Android/i.test(ua)
    ? 'android'
    : /\biPad|iPhone|iPod\b/.test(ua)
    ? 'ios'
    : undefined
  ua.replace(
    new RegExp(`(?:\\s|^)(?:akulaku|silvrrplus)\\/(.+?)(?:\\s|$)`),
    ($0, $1) => {
      result.version = $1
    }
  )
  return result
}
